import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = () => {
  const location = useLocation();
  const pathSegments = location?.pathname?.split('/')?.filter(segment => segment);

  if (pathSegments?.length === 0) {
    return null;
  }

  const breadcrumbItems = [
    { label: 'Home', path: '/' }
  ];

  let currentPath = '';
  pathSegments?.forEach((segment, index) => {
    currentPath += `/${segment}`;
    
    const label = segment?.split('-')?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1))?.join(' ');
    
    breadcrumbItems?.push({
      label,
      path: currentPath,
      isLast: index === pathSegments?.length - 1
    });
  });

  return (
    <nav 
      className="flex items-center gap-2 py-4 text-sm overflow-x-auto"
      aria-label="Breadcrumb"
    >
      {breadcrumbItems?.map((item, index) => (
        <React.Fragment key={item?.path}>
          {index > 0 && (
            <Icon 
              name="ChevronRight" 
              size={16} 
              color="var(--color-muted-foreground)"
              className="flex-shrink-0"
            />
          )}
          {item?.isLast ? (
            <span 
              className="text-foreground font-medium whitespace-nowrap"
              aria-current="page"
            >
              {item?.label}
            </span>
          ) : (
            <Link
              to={item?.path}
              className="text-muted-foreground hover:text-foreground transition-smooth whitespace-nowrap"
            >
              {item?.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;